import { useState } from "react";
import { Spinner } from "react-bootstrap";
import "./style.css";

const FloatingFunnel = ({
  title,
  message,
  notes,
  email,
  agree,
  error,
  loading,
  onErrorChange,
  onEmailChange,
  onAgreeChange,
  onSubmit,
  t,
}) => {
  const [minimized, setMinimized] = useState(false);

  if (minimized) {
    return (
      <button
        className="floating-funnel-toggle"
        onClick={() => setMinimized(false)}
        title="Open Funnel"
      >
        <span>
          <i className="fas fa-envelope" />
        </span>
      </button>
    );
  }

  return (
    <div className="floating-funnel flex justify-content-between align-items-center">
      <div>
        <div className="funnel-header">
          <div className="funnel-glow"></div>

          <div>
            <h6 className="floating-funnel-title">{title}</h6>
            {message && <p className="floating-funnel-message">{message}</p>}
          </div>

          <button
            className="floating-funnel-close"
            onClick={() => setMinimized(true)}
          >
            <span>
              <i className="fas fa-times" />
            </span>
          </button>
        </div>

        {notes && <p className="floating-funnel-notes">{notes}</p>}
      </div>
      <div>
        <div className="funnel-form">
          <input
            type="email"
            placeholder={t("funnelEmailPlaceholder") || t("placeholder")}
            className={`site-input pe-5 ${error ? "is-invalid" : ""}`}
            value={email}
            onChange={(e) => {
              onEmailChange(e.target.value);

              if (error === t("enterEmail") || error === t("validEmail")) {
                // Clear email-related errors when user types
                onErrorChange?.("");
              }
            }}
            disabled={loading}
          />

          <button
            type="button"
            className="transparent-btn floating-funnel-submit"
            onClick={onSubmit}
            disabled={loading}
          >
            {loading ? (
              <span key="spinner">
                <Spinner size="sm" />
              </span>
            ) : (
              <span key="icon">
                <i className="fas fa-arrow-right" />
              </span>
            )}
          </button>
        </div>

        {error && <div className="invalid-feedback d-block ms-4">{error}</div>}

        <label className="custom-checkbox-label ms-4 mt-2 mb-3">
          <input
            type="checkbox"
            className="checkbox-input"
            checked={agree}
            onChange={(e) => {
              onAgreeChange(e.target.checked);

              if (e.target.checked && error === t("funnerCheckError")) {
                onErrorChange?.("");
              }
            }}
            disabled={loading}
          />

          <span className="custom-checkbox">
            <span className="checkmark" />
          </span>

          {t("funnelEmailUpdate")}
        </label>
      </div>
    </div>
  );
};

export default FloatingFunnel;
